import Ajax from "Utils/ajax";
export const leaveMatrix = (data) => Ajax.post('hr/leaveMatrix',data);
export const getMissedPunchList = (data) => Ajax.post('hr/getMissedPunchList',data);
export const insertMissedPunchDetails = (data) => Ajax.post('hr/insertMissedPunchDetails',data);
export const deleteMissedPunchListById = (data) => Ajax.post('hr/deleteMissedPunchListById',data);
export const getUserNameById = (data) => Ajax.post('hr/getUserNameById',data);
export const getMissedPunchListById = (data) => Ajax.post('hr/getMissedPunchListById',data);
export const updateMissedPunchStatus = (data) => Ajax.post('hr/updateMissedPunchStatus',data);